import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { API_ROUTES, Utils } from "../utils/utils";

@Injectable()
export class BranchExcellenceService {
    constructor(
        private readonly httpClient: HttpClient,
        @Inject('BASE_URL') private readonly baseUrl: string
    ) { }

    getKpiStageResultsHhistory(waveId: number, callback: any | undefined = undefined, errorCallback: any | undefined = undefined) {
        const url = `${this.baseUrl}${API_ROUTES.API_BRANCHEXCELLENCE}/kpi-stage-results-history/${waveId}`;
        this.httpClient.get(url).subscribe({
            next: response => {
                if (callback)
                    callback(response);
            }, error: error => {
                Utils.writeLog(this.httpClient, this.baseUrl, error);
                if (errorCallback)
                    errorCallback(error);
            }
        }
        );
    }

    getAccountsByGF(
        tthis: any | undefined = undefined,
        callback: any | undefined = undefined,
        callbackError: any | undefined = undefined) {

        const url = this.baseUrl + API_ROUTES.API_BRANCHEXCELLENCE + '/accountsbygf';
        this.httpClient.get<any>(url).subscribe({
          next: (result) => {
              if (tthis && callback)
                callback(tthis, result);
          },
          error: (error) => {
            if (callbackError) {
                callbackError(tthis, error);
            }
          }
        });
    }

    updateAssessmentBestPractices(
        mgmtId: string,
        waveId: number,
        isChecked : boolean,
        callbackSuccess: ((tthis: any, callResult : boolean) => void) | undefined,
        callbackError: ((tthis: any, error: string) => void) | undefined,
        tthis: any = undefined){

        const url = `${this.baseUrl}${API_ROUTES.API_BRANCHEXCELLENCE}/update/bestPractices/${mgmtId}/${waveId}`;
        this.httpClient
            .put<boolean>(url, {isChecked}).subscribe({
              next: (res) => {
                if (tthis && callbackSuccess)
                    callbackSuccess(tthis, res);
              },
              error: (error) => {
                if (tthis && callbackError)
                    callbackError(tthis, error);
              },
            })
    }
}